<template>
  <div
    v-loading="loading"
    class="grid-view"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div class="main-content">
      <div class="section operations">
        <div class="triggers">
          <div style="display: inline-block;">
            <el-select v-model="timeRange" style="width: 100px;" @change="onTimeRangeChange">
              <el-option v-for="(item,index) in TIME_RANGES" :key="index" :label="$store.getters.language === 'zh'?item.chineseName:item.englishName" :value="item.code" />
            </el-select>
            <el-date-picker
              v-model="filter.estimatedDateOfWarehousingeStart"
              :disabled="timeRange!==CUSTOM.code"
              type="date"
              value-format="yyyy-MM-dd"
              :editable="false"
              :clearable="false"
              style="width: 120px;margin:0 5px;"
            />-
            <el-date-picker
              v-model="filter.estimatedDateOfWarehousingeEnd"
              :disabled="timeRange!==CUSTOM.code"
              type="date"
              value-format="yyyy-MM-dd"
              :editable="false"
              :clearable="false"
              style="width: 120px;margin-left: 5px;"
            />
            <span class="input-label" style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_WarehouseNo') }}:</span>
            <el-input v-model="filter.warehouseNo" style="width: 150px;" />
            <el-button type="primary" @click="queryJobs()">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            <el-checkbox v-model="autoRefresh" style="margin: 0 5px;" @change="resetTimer">{{ $t('SeaExport.AutomaticallyRefresh') }}</el-checkbox>
          </div>
        </div>
      </div>
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        class="section grid-wrapper"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
  </div>
</template>

<script>
import LocalStorageUtils from '@/utils/localStorageUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { YESTERDAY, TODAY, TOMORROW, CUSTOM } from '@/class/cargo/model/parameters/RouteConstants'
import { calcTimeRange } from '@/class/cargo/model/parameters/RouteConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { complexQueryAeJobs } from '@/api/AirExport/airExportJob'

export default {
  name: 'StayUploadPhotoWarehousing',
  data() {
    return {
      loading: false,
      TIME_RANGES: [YESTERDAY, TODAY, TOMORROW, CUSTOM],
      CUSTOM,
      timeRange: TODAY.code,
      filter: {
        estimatedDateOfWarehousingeStart: '',
        estimatedDateOfWarehousingeEnd: '',
        warehouseNo: ''
      },
      autoRefresh: LocalStorageUtils.getConfiguration('STAY_UPLOAD_PHOTO_WAREHOUSE_AUTO_REFRESH') || false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
              field: 'jobNo',
              width: 150
            },
            {
              headerName: this.$t('CargoMsg.Cargo_WarehouseNo'),
              field: 'warehouseNo',
              width: 150
            }, {
              headerName: this.$t('CargoMsg.Cargo_MblNo'),
              field: 'mbl',
              width: 130,
              cellRenderer: params => {
                return ColumnUtils.mawbNoLabelFun(params.value)
              }
            }, {
              headerName: this.$t('SeaExport.FlightNo'),
              field: 'voyageFlight',
              width: 110
            }, {
              headerName: this.$t('CargoMsg.Cargo_FlightDate'),
              field: 'etd',
              cellRenderer: params => {
                return ColumnUtils.dateLabelFunc(params.value)
              },
              width: 110
            }
          ]
        }, {
          headerName: this.$t('CargoMsg.Cargo_Consignation'),
          children: [
            {
              headerName: this.$t('SeaExport.Piece'),
              field: 'quantityContract',
              width: 100,
              cellRenderer: params => {
                const txt = ColumnUtils.formatNumber(params.value, 0, true)
                return '<i>' + txt + '</i>'
              }
            }, {
              headerName: this.$t('queryJob.heavy'),
              field: 'weightContract',
              width: 100,
              cellRenderer: params => {
                const txt = ColumnUtils.formatNumber(params.value, 1, true)
                return '<i>' + txt + '</i>'
              }
            }, {
              headerName: this.$t('SeaExport.Volume'),
              field: 'cubageContract',
              width: 100,
              cellRenderer: params => {
                const txt = ColumnUtils.formatNumber(params.value, 3, true)
                return '<i>' + txt + '</i>'
              }
            }
          ]
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      timerId: 0 // 定时器ID
    }
  },
  created() {
    this.onTimeRangeChange()
    this.queryJobs()
  },
  methods: {
    onTimeRangeChange() {
      const dateArray = calcTimeRange(this.timeRange)
      if (dateArray) {
        this.filter.estimatedDateOfWarehousingeStart = dateArray[0]
        this.filter.estimatedDateOfWarehousingeEnd = dateArray[1]
      }
    },
    queryJobs(operator = '') {
      const conditions = [
        new AdvancedSearchOption(null, 'job.JOB_STATE', 0).formatObj2Json(),
        new AdvancedSearchOption(null, 'airExportJob.LOADING_TERM', AirExportConstants.TP_STUFFY_TYPE.code, AdvancedSearchConsts.OPERATOR_UNEQUAL.code).formatObj2Json(),
        new AdvancedSearchOption(null, 'airExportJob.TAKE_PHOTOS', true).formatObj2Json(),
        new AdvancedSearchOption(null, 'airExportJob.OWN_WAREHOUSE', true).formatObj2Json(),
        new AdvancedSearchOption(null, 'stayUploadWarehousePhoto').formatObj2Json(),
        new AdvancedSearchOption(null, 'businessDocument.UUID', null, AdvancedSearchConsts.OPERATOR_IS_NULL.code).formatObj2Json(),
        new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json(),
        new AdvancedSearchOption(
          null,
          'airExportJob.ESTIMATED_DATE_OF_WAREHOUSINGE',
          `type=date,start=${this.filter.estimatedDateOfWarehousingeStart} 00:00:00,end=${this.filter.estimatedDateOfWarehousingeEnd} 23:59:59`,
          AdvancedSearchConsts.OPERATOR_RANGE.code
        ).formatObj2Json()
      ]
      if (this.filter.warehouseNo.trim()) {
        conditions.push(new AdvancedSearchOption(null, 'job.WAREHOUSE_NO', this.filter.warehouseNo, AdvancedSearchConsts.OPERATOR_LIKE.code).formatObj2Json())
      }
      this.loading = true
      complexQueryAeJobs({ conditions, branchId: this.$store.getters.currentOfficeId, useAdmin: true, pageNum: 1, pageSize: 1000 }).then(res => {
        this.rowData = res.data.list
        if (operator !== 'timer') {
          this.resetTimer()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    resetTimer() {
      LocalStorageUtils.setConfiguration('STAY_UPLOAD_PHOTO_WAREHOUSE_AUTO_REFRESH', this.autoRefresh)
      this.closeTimer()
      if (this.autoRefresh) {
        this.timerId = setInterval(() => {
          this.queryJobs('timer')
        }, 5 * 60 * 1000)
      }
    },
    closeTimer() {
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  padding: 0 5px;
  color: #666666;
}
#app .grid-view .main-content ::v-deep {
  .grid-wrapper {
    .ag-header-group-cell-no-group {
      display: none;
    }
    .ag-header-group-cell-label {
      justify-content: center;
    }
    .ag-theme-balham {
      .ag-row-hover {
        background: #9bddff !important;
      }
    }
  }
}
</style>
